<script>
import Layout from "../../layouts/main";
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Quote from "@/services/westore/entities/quote";
import moment from "moment";
import ContentLoader from "@/router/views/spinner/loader";

export default {
  page: {
    title: "Quote Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout, PageHeader, ContentLoader
  },
  props: {
    rowData: {
      type: Object,
      default:null,
    },
  },
  data() {
    return {
      title: "Quote Details",
      itemDetails: null,
      loaded: true,
      showContentLoader:false,
    };
  },
  created() {
    this.itemDetails = this.rowData
    if (!this.rowData){
      this.fetchDetails(this.$route.params.id);
    }
  },
  methods: {
    async fetchDetails(id) {
      this.loaded = false;
      this.showContentLoader = true;

      await Quote.getOne(id).then(res => {
        this.itemDetails = res.data;
      }).finally(()=>{
        this.loaded = true;
        this.showContentLoader = false;
      });
    },
    convertDate: function (timestampValue) {
      return moment.unix(timestampValue).format("DD/MM/YYYY")
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" class="d-print-none"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <ContentLoader v-if="showContentLoader"/>
          <div class="card-body" v-if="showContentLoader === false && loaded && itemDetails !== null">
            <h4 class="card-title mb-4 p-2">
              <span>{{$t('Quote')}} <code class="pink--text">#{{this.itemDetails.quote_number}}</code></span>
              <div class="mb-4 float-end hide-from-screen">
                <img
                    src="@/assets/images/logo-dark.png"
                    alt="logo"
                    height="20"
                />
              </div>
            </h4>
            <!-- Details -->
            <div class="table-responsive ">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">{{$t('CREATED AT')}}</th>
                  <td>{{ convertDate(itemDetails.created) }}</td>
                </tr>
                <tr>
                  <th scope="row">{{$t('Status')}}</th>
                  <td>{{this.itemDetails.status_text}}</td>
                </tr>
                <tr>
                  <th scope="row">{{$t('I Need')}}</th>
                  <td><li v-for="service in this.itemDetails.services" :key="service.name">
                    {{ service.name }}
                  </li></td>
                </tr>
                <tr>
                  <th scope="row">{{$t('Product Type')}}</th>
                  <td><li v-for="ptype in this.itemDetails.product_types" :key="ptype.name">
                    {{ ptype.name }}
                  </li></td>
                </tr>
                <tr>
                  <th scope="row">{{$t('Shipment is coming in')}}</th>
                  <td>{{this.itemDetails.shipment_type_text}}</td>
                </tr>
                <tr>
                  <th scope="row">{{$t('ITEMS INSURED')}}</th>
                  <td>{{this.itemDetails.product_insured ? 'YES' : 'NO'}}</td>
                </tr>
                <tr>
                  <th scope="row">{{$t('Warehouse Location')}}</th>
                  <td>{{this.itemDetails.city_name}}</td>
                </tr>
                <tr>
                  <th scope="row">{{$t('TEMPERATURE CONTROL')}}</th>
                  <td>{{this.itemDetails.temperature_text}}</td>
                </tr>
                <tr>
                  <th scope="row">{{$t('PACKING')}}</th>
                  <td>{{this.itemDetails.packaging_type_text}}</td>
                </tr>
                <tr>
                  <th scope="row">{{$t('Inbound Shipments')}}</th>
                  <td>{{this.itemDetails.shipment_handling_text}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- Back and get support buttons -->
            <div class="d-flex align-items-center mt-4 d-print-none">
              <router-link :to="{ name: 'support-tickets-list'}">
                <b-btn class="btn btn-info"> <i class="bx bx-arrow-back"></i> {{$t('Back')}}</b-btn>
              </router-link>
              <div class="">
                <a href="javascript:window.print()" :class="isRtl ? 'btn btn-success mr-2':'btn btn-success ml-2'"><i class="fa fa-print text-white"></i></a>
                <router-link :to="{ name: 'get-support'}">
                  <b-btn :class="isRtl ? 'btn btn-warning float-end mr-2':'btn btn-warning float-end ml-2'"><i class="bx bx-support"></i> {{$t('Get Support')}}</b-btn>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
@media screen {
  .hide-from-screen {
    display: none;
  }
}
</style>